import { useState } from 'react';
import { useAuth } from '#global/context/auth/useAuth.tsx';
import { useUrlParam } from '#hooks/useUrlParam.ts';
import { DeleteAccountModal } from '#screens/settings/user/delete/modal/DeleteAccountModal.tsx';
import { DeleteAccountBanner } from './banner/DeleteAccountBanner.tsx';

export function AccountDeletion() {
  const { user } = useAuth();
  const [prefillParam, setPrefillParam] = useUrlParam('prefill');
  const [isDeletingAccount, setDeletingAccount] = useState(false);

  if (!user) {
    return null;
  }

  // Paid orgs can't be deleted directly — they must downgrade to the free plan first. Show the banner
  // with a disabled button + explanatory tooltip rather than hiding the section entirely.
  const isPaid = user.organization.plan !== 'free';

  return (
    <>
      <DeleteAccountBanner
        onRequestDelete={() => {
          setDeletingAccount(true);
        }}
        disabledReason={isPaid ? 'You can’t delete your account until you downgrade to the free plan.' : undefined}
      />
      {!isPaid && (isDeletingAccount || prefillParam) ?
        <DeleteAccountModal
          orgName={user.organization.name}
          prefilled={Boolean(prefillParam)}
          orgId={user.organizationID}
          email={user.email}
          onClose={() => {
            setPrefillParam();
            setDeletingAccount(false);
          }}
        />
      : null}
    </>
  );
}
